module.exports = __webpack_public_path__ + "img/labmem_text_btnfinish_jp.0e5ecf41.png";